import React, { useCallback, useContext, useMemo } from 'react';
import { Button } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { PlaybackState } from '../../PlaybackState';
import { PlaybackInformationContext } from '../../../../contexts/PlaybackInformationContext';

const { PLAYING, BUFFERING, IDLE, PAUSED, LOADING } = PlaybackState;

export const PlayStateIcon: React.FC = () => {
	const { player, playbackState } = useContext(PlaybackInformationContext);

	const iconClass = useMemo(() => {
		switch (playbackState) {
			case PLAYING:
				return 'playing';
			case PAUSED:
				return 'paused';
			case BUFFERING:
			case IDLE:
			case LOADING:
			default:
				return 'buffering';
		}
	}, [playbackState]);

	const onIconClick = useCallback(
		(e) => {
			e.preventDefault();
			player?.togglePausePlay();
		},
		[player]
	);

	return <Button className={['player-state-icon', iconClass].join(' ')} onClick={onIconClick} />;
};
